import { ContentTypeEnum } from '@elearning-platform/api-types/enums';

import { AppLanguage } from '../enums';
import { ContentHashRoute } from '../interfaces';

export const contentHashRoutes: Record<AppLanguage, ContentHashRoute[]> = {
  pl: [
    { prefix: 'multimedia', type: ContentTypeEnum.contents },
    { prefix: 'pliki', type: ContentTypeEnum.files },
  ],
  en: [
    { prefix: 'multimedia', type: ContentTypeEnum.contents },
    { prefix: 'files', type: ContentTypeEnum.files },
  ],
};
